// extracted by mini-css-extract-plugin
module.exports = {"log":"style_log__idhSi","header":"style_header__R3EQz","time":"style_time__uPKaj","info":"style_info__dJfm8","warn":"style_warn__h8xZQ","error":"style_error__rZAqB"};